import React, { Fragment, Component } from 'react';
import Editor from "componentes/editor";
import { connect } from "react-redux";
import {
  Button,
  Col,
  Row,
  Card,
  CardBody,
  Collapse,
  Container
} from 'reactstrap';

import { CardHeader } from "componentes/uteis";
import ProcessoParecerForm from "componentes/ProcessoParecerForm";

import { FaAngleDoubleDown, FaAngleDoubleUp } from 'react-icons/lib/fa/';


class ProcessoDetalhe extends Component {
  constructor(props) {
    super(props);
    this.state = { alternarTodos: false };
  }

  alternar = id => {
    this.setState({ [`expandido_${id}`]: !this.state[`expandido_${id}`] });
  }

  alternarTodos = () => {
    [...document.querySelectorAll(".card-header i")]
      .forEach(({ id }) => this.setState({ [`expandido_${id}`]: !this.state.alternarTodos }));
    this.setState({ alternarTodos: !this.state.alternarTodos })
  }

  render() {
    const {
      requerente,
      processo,
      infracao,
      parecer
    } = this.props;

    const { endereco: enderecoRequerente = {} } = requerente;

    const {
      dataHora: dh = "",
      endereco: enderecoInfracao = {},
      veiculo = {},
      condutor = {}
    } = infracao;
    const dataHoraInfracao = new Date(dh).toLocaleString();

    const {
      dataApresentacao: dhApresentação = "",
      dataAbertura: dtAbertura = "",
      dataUltimaAtualizacao: dtAtualizacao = "",
      fase = {},
      situacao = {},
      responsavel = {} } = processo;
    const dataHoraApresentação = new Date(dhApresentação).toLocaleString();
    const dataHoraAbertura = new Date(dtAbertura).toLocaleString();
    const dataUltimaAtualizacao = new Date(dtAtualizacao).toLocaleString();
    const situacaoAtual = situacao.descricao;

    var imagem = <FaAngleDoubleDown/>;

    if (this.state.alternarTodos === false){
       imagem = <FaAngleDoubleDown/>;
  
    }  else
    {
       imagem = <FaAngleDoubleUp/>;
     
    }

    return (
      <Fragment>
        <Container>
          <Row>
            <Col sm={12} className="text-right">
              <Button onClick={this.alternarTodos}> {imagem}  </Button>
            </Col>
          </Row>
        </Container>
        <Card tag="fieldset">
          <CardHeader
            tag="legend"
            id="processo"
            onClick={this.alternar}
            titulo="Dados do Processo"
            expandido={this.state["expandido_processo"]}
             />
          <Collapse tag={CardBody} isOpen={this.state["expandido_processo"]}>
            <Row tag="dl">
              <Col tag="dt" sm={4}>Número Legado</Col>
              <Col tag="dt" sm={4}>Data Apresentação</Col>
              <Col tag="dt" sm={4}>Fase</Col>

              <Col tag="dd" sm={4}>{processo.numeroLegado}</Col>
              <Col tag="dd" sm={4}>{dataHoraApresentação}</Col>
              <Col tag="dd" sm={4}>{fase.nome}</Col>

              <Col tag="dt" sm={4}>Situação</Col>
              <Col tag="dt" sm={4}>Data Abertura</Col>
              <Col tag="dt" sm={4}>Nº Processo no SEI</Col>

              <Col tag="dd" sm={4}>{situacao.descricao}</Col>
              <Col tag="dd" sm={4}>{dataHoraAbertura}</Col>
              <Col tag="dd" sm={4}>{}</Col>

              <Col tag="dt" sm={4}>Responsável</Col>
              <Col tag="dt" sm={4} offset={4}>Data Atualização</Col>

              <Col tag="dd" sm={4}>{responsavel.nome}</Col>
              <Col tag="dd" sm={4} offset={4}>{dataUltimaAtualizacao}</Col>

              <Col tag="dt" sm={12}>Alegações</Col>
              <Col tag="dd" sm={12}>
                <Editor conteudo={processo.alegacoes} somenteLeitura />
              </Col>
            </Row>
          </Collapse>
        </Card>
        <Card tag="fieldset">
          <CardHeader
            tag="legend"
            id="infracao"
            onClick={this.alternar}
            titulo="Infração"
            expandido={this.state["expandido_infracao"]} />
          <Collapse tag={CardBody} isOpen={this.state["expandido_infracao"]}>
            <Row tag="dl">
              <Col tag="dt" sm={4}>Auto de Infração</Col>
              <Col tag="dt" sm={4}>Código</Col>
              <Col tag="dt" sm={4}>Data Hora</Col>

              <Col tag="dd" sm={4}>{infracao.autoInfracao}</Col>
              <Col tag="dd" sm={4}>{infracao.codigo}</Col>
              <Col tag="dd" sm={4}>{dataHoraInfracao}</Col>

              <Col tag="dt" sm={12}>Endereço</Col>
              <Col tag="dd" sm={12}>{enderecoInfracao.logradouro}</Col>

              <Col tag="dt" sm={12}>Descrição</Col>
              <Col tag="dd" sm={12}>{infracao.descricao}</Col>
            </Row>
            <hr />
            <Row tag="dl">
              <Col tag="dt" sm={12}>Condutor</Col>
              <Col tag="dd" sm={12}>{condutor.nome}</Col>
            </Row>
            <hr />
            <Row tag="dl">
              <Col tag="dt" sm={6}>Renavam</Col>
              <Col tag="dt" sm={6}>Placa</Col>

              <Col tag="dd" sm={6}>{veiculo.renavam}</Col>
              <Col tag="dd" sm={6}>{veiculo.placa}</Col>

              <Col tag="dt" sm={4}>Modelo</Col>
              <Col tag="dt" sm={4}>Cor</Col>
              <Col tag="dt" sm={4}>UF</Col>

              <Col tag="dd" sm={4}>{veiculo.marcaModelo}</Col>
              <Col tag="dd" sm={4}>{veiculo.cor}</Col>
              <Col tag="dd" sm={4}>{veiculo.ufJurisdicao}</Col>
            </Row>
          </Collapse>
        </Card>
        <Card tag="fieldset">
          <CardHeader
            tag="legend"
            id="requerente"
            onClick={this.alternar}
            titulo="Requerente"
            expandido={this.state["expandido_requerente"]} />
          <Collapse tag={CardBody} isOpen={this.state["expandido_requerente"]}>
            <Row tag="dl">
              <Col tag="dt" sm={4}>Nome</Col>
              <Col tag="dt" sm={4}>CPF</Col>
              <Col tag="dt" sm={4}>CNH</Col>

              <Col tag="dd" sm={4}>{requerente.nome}</Col>
              <Col tag="dd" sm={4}>{requerente.cpf}</Col>
              <Col tag="dd" sm={4}>{requerente.cnh}</Col>

              <Col tag="dt" sm={4}>Telefone</Col>
              <Col tag="dt" sm={4} offset={4}>Email</Col>

              <Col tag="dd" sm={4}>{requerente.telefone}</Col>
              <Col tag="dd" sm={4} offset={4}>{requerente.email}</Col>

              <Col tag="dt" sm={12}>Endereço</Col>
              <Col tag="dd" sm={12}>{enderecoRequerente.logradouro}, {enderecoRequerente.numero}, {enderecoRequerente.bairro}, {enderecoRequerente.estado}</Col>
            </Row>
          </Collapse>
        </Card>
        {
          (situacaoAtual === "Aguardando Decisão" ||
            situacaoAtual === "Executado")
          &&
          <Card tag="fieldset">
            <CardHeader
              tag="legend"
              id="parecer"
              onClick={this.alternar}
              titulo="parecer"
              expandido={this.state["expandido_parecer"]} />
            <Collapse tag={CardBody} isOpen={this.state["expandido_parecer"]}>
              <ProcessoParecerForm parecer={parecer} somenteLeitura />
            </Collapse>
          </Card>
        }
        <Container>
          <Row>
            <Col sm={12} className="text-right">
              <Button onClick={this.alternarTodos}>{imagem}</Button>
            </Col>
          </Row>
        </Container>

      </Fragment>
    );
  };
}

const mapStateToProps = state => ({
  processo: state.processo.processo,
  infracao: state.processo.infracao,
  requerente: state.processo.requerente,
  parecer: state.parecer.parecer
})

export default connect(
  mapStateToProps
)(ProcessoDetalhe)



// WEBPACK FOOTER //
// ./src/componentes/ProcessoDetalhe.js